import React, { useEffect } from 'react';

import { activateInvestorOrganizations } from 'modules/investmentAssets/repository';
import { SessionService } from 'modules/session/sessionService';

import { useNavigate, useSearchParams } from 'react-router-dom';
import { ROUTE_PATH } from 'routes';
import { useSelector } from 'react-redux';

import useDialog from 'components/Dialog/useDialog';
import OutputErrors from 'components/Inputs/outputErrors';

function PaymentSuccess() {
  const literals = useSelector(state => state.i18n.literals.investmentAssets);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  const { dialog } = useDialog();

  const handleSendSessionId = async () => {
    if (!sessionId) return;
    await dialog({
      type: 'loading',
      execute: async () => {
        try {
          await activateInvestorOrganizations(sessionId);
          SessionService.refreshUser();
          await dialog({
            type: 'success',
            title: literals.paymentSuccess,
            text: literals.paymentSuccessDescription,
          });
          navigate(ROUTE_PATH.INVESTOR_ORGANIZATIONS);
        } catch (err) {
          dialog({ type: 'error', text: <OutputErrors errors={err} text /> });
        }
      },
    });
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { handleSendSessionId(); }, [sessionId]);

  return null;
}

PaymentSuccess.displayName = 'PaymentSuccess';
export default PaymentSuccess;
